module.exports = __webpack_public_path__ + "cd455783/img/note-edit-icon.acae1669.svg";